import { OfficeBuildingIcon, UserIcon } from "@heroicons/react/solid";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import SideBar from "../../components/b2b/SideBar";
import Header from "../../components/landingPage/Header";
// import TreeView from "@mui/lab/TreeView";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
// import TreeItem from "@mui/lab/TreeItem";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Modal from "../../components/b2b/Modal";
// import { TreeView } from "@mui/x-tree-view/TreeView";
import { TreeItem } from "@mui/x-tree-view/TreeItem";
import { SimpleTreeView } from "@mui/x-tree-view/SimpleTreeView";
import {
  faBuilding,
  faEdit,
  faEnvelope,
  faGlobe,
  faKey,
  faLock,
  faLockOpen,
  faMobile,
  faPhone,
  faPlus,
  faTrash,
  faUser,
  faUserPlus,
} from "@fortawesome/fontawesome-free-solid";
import {
  faBuildingUser,
  faLocationPin,
  faMoneyBill1Wave,
  faUserGear,
  faUserPen,
  faSearch,
  faSquareEnvelope,
} from "@fortawesome/free-solid-svg-icons";

import { CircularProgress, Switch, TextField } from "@mui/material";
import { editUserAction } from "../../api/auth-action";
import { toast } from "react-toastify";
import Select from "react-select";

const UserManagement = () => {
  const dispatch = useDispatch();
  const { token, user } = useSelector((state) => state.auth);
  const { allRegionsOrSearch } = useSelector((state) => state.region);
  const {
    companyDetails,
    search,
    eachCompanyDetails,
    eachUserDetails,
    allCompany,
    companyDetailsLoading,
    isSearchLoading,
  } = useSelector((state) => state.company);
  const [updatePasswordModal, setupdatePasswordModal] = useState(false);
  const [updatedPaswordValue, setupdatedPaswordValue] = useState();

  const [openEditCompany, setopenEditCompany] = useState(false);
  const [company, setCompany] = useState();
  const [companyCityPrice, setcompanyCityPrice] = useState([]);
  const [userCityPrice, setuserCityPrice] = useState([]);
  const [newcityprice, setnewcityprice] = useState({});
  const [newusercityprice, setnewusercityprice] = useState({});

  const options = [];

  allRegionsOrSearch?.forEach((region) => {
    options.push({ value: region.name, label: region.name });
  });

  useEffect(() => {
    dispatch({
      type: "GET_ALL_REGION_OR_SEARCH",
      payload: undefined,
    });
  }, []);

  // useEffect(() => {
  //   dispatch({
  //     type: "GET_COMPANY",
  //     payload: { token, companyid: user?.company?._id },
  //   });
  // }, [dispatch, token, user]);
  useEffect(() => {
    dispatch({
      type: "GET_ALL_COMPANY",
      payload: { token },
    });
  }, [token, dispatch]);

  useEffect(() => {
    allCompany?.map((company) => {
      return company?.users?.map((companyuser) => {
        return companyuser?.userName === user?.userName && setCompany(company);
      });
    });
  }, [user, allCompany]);

  const [searchInputLength, setsearchInputLength] = useState(0);
  const [searchCharecters, setsearchCharecters] = useState();
  const handleSearch = (e) => {
    e.preventDefault();
    setsearchInputLength(e.target.value.length);
    setsearchCharecters(e.target.value);
    if (e.target.value.length > 0) {
      // dispatch({
      //   type: "SEARCH",
      //   payload: e.target.value,
      // });
    } else {
      dispatch({ type: "GET_COMPANY", payload: token });
    }
  };

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     dispatch({
  //       type: "SEARCH",
  //       payload: searchCharecters,
  //     });
  //   }, 200);

  //   return () => clearTimeout(timer);
  // }, [searchCharecters, dispatch]);

  useEffect(() => {
    if (searchInputLength > 0) {
      const timer = setTimeout(() => {
        dispatch({
          type: "SEARCH",
          payload: {
            searchCharecters,
            companyId: user?.company?._id,
          },
        });
      }, 200);
      return () => clearTimeout(timer);
    }
  }, [searchCharecters, dispatch, user]);

  const [showModal, setShowModal] = React.useState(false);
  const [showModalCompany, setShowModalCompany] = React.useState(false);
  const [showPermissionModal, setShowPermissionModal] = useState(false);
  const [userDetailBody, setuserDetailBody] = useState({
    userName: "",
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    password: "",
    confirmPassword: "",
  });

  const [companyDetailBody, setcompanyDetailBody] = useState({
    companyName: "",
    companyEmail: "",
    companyAddress: "",
    companyWebsite: "",
    gst_vat: "",
  });

  const [isSelectComapnyDetail, setIsSelectComapnyDetail] = useState(false);
  const [isSelect, setisSelect] = useState(false);
  const [openUserEditModal, setOpenUserEditModal] = useState(false);

  const [setError, setsetError] = useState("");

  useEffect(() => {
    if (localStorage.getItem("newbookingreload")) {
      localStorage.removeItem("newbookingreload");
    }
  }, []);

  const addUserHandler = () => {
    if (
      userDetailBody.userName === "" ||
      userDetailBody.firstName === "" ||
      userDetailBody.lastName === "" ||
      userDetailBody.email === "" ||
      userDetailBody.mobile === "" ||
      userDetailBody.password === "" ||
      userDetailBody.confirmPassword === ""
    ) {
      toast.warn("All fields are required!");
    } else if (userDetailBody.password !== userDetailBody.confirmPassword) {
      toast.warn("Password and Confirm Password must be same");
    } else {
      const userPayload = {
        userName: userDetailBody.userName,
        firstName: userDetailBody.firstName,
        lastName: userDetailBody.lastName,
        email: userDetailBody.email,
        password: userDetailBody.password,
        mobile: userDetailBody.mobile,
      };
      dispatch({
        type: "ADD_USER",
        payload: {
          body: userPayload,
          token,
          parentCompanyid: eachCompanyDetails
            ? eachCompanyDetails._id
            : companyDetails?._id,
        },
      });
      setShowModal(false);
    }
  };

  const addCompanyHandler = () => {
    if (
      companyDetailBody.companyName === "" ||
      companyDetailBody.companyEmail === ""
    ) {
      toast.warn("Company Name and Company Email required !");
    } else {
      setShowModalCompany(false);
      const companyPayload = {
        companyName: companyDetailBody.companyName,
        email: companyDetailBody.companyEmail,
        website: companyDetailBody.companyWebsite,
        address: companyDetailBody.companyAddress,
        gst_vat: companyDetailBody.gst_vat,
      };
      dispatch({
        type: "ADD_COMPANY",
        payload: {
          body: companyPayload,
          token,
          parentCompanyId: eachCompanyDetails
            ? eachCompanyDetails._id
            : companyDetails?._id,
        },
      });
    }
  };

  // edit company
  const [editCompanyDetail, seteditCompanyDetail] = useState({
    companyId: "",
    companyName: "",
    email: "",
    website: "",
    address: "",
    gst_vat: "",
    creditLimit: "",
    discount: "",
    markUp: "",
  });

  // edit user
  const [editUserDetail, seteditUserDetail] = useState({
    userName: "",
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    userMarkup: "",
    userDiscount: "",
  });

  const companyEditFormData = new FormData();
  const [companyLogo, setcompanyLogo] = useState();

  const [userPermissionUpdate, setUserPermissionUpdate] = useState({
    newBooking: {
      permission: eachUserDetails?.permission?.newBooking?.permission,
      performSearch: {
        permission:
          eachUserDetails?.permission?.newBooking?.performSearch?.permission,
      },
      MakeBooking: {
        permission:
          eachUserDetails?.permission?.newBooking?.MakeBooking?.permission,
      },
      Requestbooking: {
        permission:
          eachUserDetails?.permission?.newBooking?.Requestbooking?.permission,
      },
    },
    flatRateBooking: {
      permission: eachUserDetails?.permission?.flatRateBooking?.permission,
    },

    manageBooking: {
      permission: eachUserDetails?.permission?.manageBooking?.permission,
      approveBooking: {
        permission:
          eachUserDetails?.permission?.manageBooking?.approveBooking
            ?.permission,
      },
      cancelRequestBooking: {
        permission:
          eachUserDetails?.permission?.manageBooking?.cancelRequestBooking
            ?.permission,
      },
      viewBooking: {
        permission:
          eachUserDetails?.permission?.manageBooking?.viewBooking?.permission,
      },
      cancelBooking: {
        permission:
          eachUserDetails?.permission?.manageBooking?.cancelBooking?.permission,
      },
      assignAffiliate: {
        permission:
          eachUserDetails?.permission?.manageBooking?.assignAffiliate
            ?.permission,
      },
      assignDriver: {
        permission:
          eachUserDetails?.permission?.manageBooking?.assignDriver?.permission,
      },
      markAsPaid: {
        permission:
          eachUserDetails?.permission?.manageBooking?.markAsPaid?.permission,
      },
      sms_Document: {
        permission:
          eachUserDetails?.permission?.manageBooking?.sms_Document?.permission,
      },
      finAmmendment: {
        permission:
          eachUserDetails?.permission?.manageBooking?.finAmmendment?.permission,
      },
      opsAmmendment: {
        permission:
          eachUserDetails?.permission?.manageBooking?.opsAmmendment?.permission,
      },
    },

    affiliate: {
      permission: eachUserDetails?.permission?.affiliate?.permission,
    },

    regions: {
      permission: eachUserDetails?.permission?.regions?.permission,
    },
    flatRegions: {
      permission: eachUserDetails?.permission?.flatRegions?.permission,
    },
    generalSettings: {
      permission: eachUserDetails?.permission?.generalSettings?.permission,
    },
    userManagement: {
      permission: eachUserDetails?.permission?.userManagement?.permission,
      view: {
        permission:
          eachUserDetails?.permission?.userManagement?.view?.permission,
      },
      edit: {
        permission:
          eachUserDetails?.permission?.userManagement?.edit?.permission,
      },
      addUsers: {
        permission:
          eachUserDetails?.permission?.userManagement?.addUsers?.permission,
      },
    },
    vehicleTypes: {
      permission: eachUserDetails?.permission?.vehicleTypes?.permission,
    },
    imageUploader: {
      permission: eachUserDetails?.permission?.imageUploader?.permission,
    },
    apiDocs: {
      permission: eachUserDetails?.permission?.apiDocs?.permission,
    },
  });

  const updateUserPermissionHandler = () => {
    dispatch({
      type: "UPDATE_PERMISSION",
      payload: {
        userId: eachUserDetails._id,
        body: userPermissionUpdate,
        token,
      },
    });
  };

  const editCompanyHandler = () => {
    companyLogo?.name && companyEditFormData.append("companyLogo", companyLogo);
    companyEditFormData.append("companyName", editCompanyDetail.companyName);
    companyEditFormData.append("email", editCompanyDetail.email);
    companyEditFormData.append("website", editCompanyDetail.website);
    companyEditFormData.append("address", editCompanyDetail.address);
    companyEditFormData.append("gst_vat", editCompanyDetail.gst_vat);
    companyEditFormData.append(
      "creditLimit",
      parseInt(editCompanyDetail.creditLimit)
    );

    // editCompanyDetail.creditLimit &&
    //   companyEditFormData.append(
    //     "availableLimit",
    //     parseInt(editCompanyDetail.creditLimit)
    //   );
    editCompanyDetail.discount &&
      companyEditFormData.append(
        "discount",
        parseInt(editCompanyDetail.discount)
      );
    editCompanyDetail.markUp &&
      companyEditFormData.append("markUp", parseInt(editCompanyDetail.markUp));

    dispatch({
      type: "EDIT_COMPANY",
      payload: {
        body: companyEditFormData,
        token,
        companyId: eachCompanyDetails._id,
      },
    });
    setopenEditCompany(false);
  };

  const editUserHandler = () => {
    const userPayload = {
      userName: editUserDetail.userName,
      firstName: editUserDetail.firstName,
      lastName: editUserDetail.lastName,
      email: editUserDetail.email,
      mobile: editUserDetail.mobile,
      markup: parseInt(editUserDetail.userMarkup),
      discount: parseInt(editUserDetail.userDiscount),
    };
    dispatch({
      type: "EDIT_USER",
      payload: {
        body: userPayload,
        token,
        userId: eachUserDetails._id,
      },
    });
    setOpenUserEditModal(false);
  };

  // ------------------------ logs ------------------------
  console.log(
    eachCompanyDetails?.companyPermission?.flatRateBooking?.MeetAndGreet,
    "eachCompanyDetails"
  );

  return (
    <div className="fixed w-screen h-screen overflow-auto scrolbar lg:h-auto lg:overflow-hidden">
      <Header token={token} />
      <div className="flex">
        <SideBar />
        <div className="w-screen mx-2 my-3 h-screen">
          <div className="2lg:flex">
            <div className="border-[1px] border-gray-200 px-2 lg:p-3 inset shadow-xl mt-2 2lg:mt-10 rounded-md 2lg:h-[85vh] mb-3 2lg:mb-10 2lg:w-2/6">
              <div className="pt-0 2lg:pt-10">
                <div className="w-24 text-sm font-bold text-primary font-body">
                  Search
                </div>
                <div className="flex items-center mr-4">
                  <input
                    onChange={handleSearch}
                    type="text"
                    placeholder="Search Company / user"
                    className="pr-5 border-b border-gray-700 w-full 2lg:w-96 focus:outline-none focus:border-primary textField"
                  />
                  <div className="mr-5">
                    {isSearchLoading ? (
                      <CircularProgress className="w-10" />
                    ) : (
                      <FontAwesomeIcon
                        icon={faSearch}
                        className="text-gray-500"
                      />
                    )}
                  </div>
                </div>
              </div>
              <SimpleTreeView
                aria-label="file system navigator"
                defaultCollapseIcon={<ExpandMoreIcon />}
                defaultExpandIcon={<ChevronRightIcon />}
                sx={{
                  height: "60vh",
                  flexGrow: 1,
                  maxWidth: 800,
                  overflowY: "auto",
                  margin: "10px 5px",
                  width: "100%",
                  overflow: "scroll",
                  fontWeight: "bold",
                  overflowX: "hidden",
                }}
                className="h-72 lg:h-[35vh] 2lg:h-[70vh] lg:overflow-y-auto scrollbar"
              >
                {searchInputLength ? (
                  <>
                    {(() => {
                      if (
                        search?.userSearchedForBranch?.length > 0 &&
                        user?.permission?.userManagement?.view?.permission ===
                          "BRANCH_LEVEL"
                      ) {
                        return (
                          <>
                            {search?.userSearchedForBranch?.map(
                              (singleUser) => (
                                <div>
                                  <TreeItem
                                    onClick={() => {
                                      setIsSelectComapnyDetail(false);
                                      dispatch({
                                        type: "GET_EACH_USER",
                                        payload: {
                                          token,
                                          userid: singleUser?._id,
                                        },
                                      });
                                      setuserCityPrice(singleUser?.cityprice);
                                    }}
                                    itemId={singleUser?._id}
                                    className="space-y-3 font-extrabold text-gray-700"
                                    label={`${singleUser?.userName} (${singleUser?.companyDetails[0]?.companyName})`}
                                    icon={
                                      <UserIcon className="text-gray-500" />
                                    }
                                  />
                                </div>
                              )
                            )}
                          </>
                        );
                      } else if (
                        search?.combinedResults?.length > 0 &&
                        user?.permission?.userManagement?.view?.permission ===
                          "CHILD_COMPANY"
                      ) {
                        return (
                          <div>
                            {search?.combinedResults?.map(
                              (singleSearch, index) =>
                                singleSearch?.companyName ? (
                                  <div key={singleSearch?._id}>
                                    <TreeItem
                                      onClick={() => {
                                        setisSelect(true);
                                        setIsSelectComapnyDetail(true);
                                        setisSelect(true);
                                        dispatch({
                                          type: "GET_EACH_COMPANY",
                                          payload: {
                                            token,
                                            id: singleSearch._id,
                                          },
                                        });
                                        setcompanyCityPrice(company?.cityprice);
                                      }}
                                      itemId={singleSearch?._id}
                                      className="space-y-1 text-yellow-900 "
                                      icon={
                                        <FontAwesomeIcon
                                          icon={faBuildingUser}
                                          className="w-5 text-yellow-900 "
                                        />
                                      }
                                      label={singleSearch?.companyName}
                                    >
                                      {singleSearch?.users?.map(
                                        (singleUser) => (
                                          <div key={singleUser?._id}>
                                            <TreeItem
                                              onClick={() => {
                                                setIsSelectComapnyDetail(false);
                                                dispatch({
                                                  type: "GET_EACH_USER",
                                                  payload: {
                                                    token,
                                                    userid: singleUser?._id,
                                                  },
                                                });
                                                setuserCityPrice(
                                                  singleUser?.cityprice
                                                );
                                              }}
                                              itemId={singleUser?._id}
                                              className="space-y-3 font-extrabold text-gray-700"
                                              label={singleUser?.userName}
                                              icon={
                                                <UserIcon className="text-gray-500" />
                                              }
                                            />
                                          </div>
                                        )
                                      )}
                                      {singleSearch?.companies?.map(
                                        (singleCompany, index) => (
                                          <div key={singleCompany?._id}>
                                            <TreeItem
                                              onClick={() => {
                                                setIsSelectComapnyDetail(true);
                                                dispatch({
                                                  type: "GET_EACH_COMPANY",
                                                  payload: {
                                                    token,
                                                    id: singleCompany._id,
                                                  },
                                                });
                                                setcompanyCityPrice(
                                                  singleCompany?.cityprice
                                                );
                                              }}
                                              itemId={index}
                                              className="space-y-1 text-yellow-900 "
                                              icon={
                                                <FontAwesomeIcon
                                                  icon={faBuildingUser}
                                                  className="w-5 text-yellow-900 "
                                                />
                                              }
                                              label={singleCompany.companyName}
                                            >
                                              {singleCompany?.users?.map(
                                                (user) => (
                                                  <>
                                                    <TreeItem
                                                      onClick={() => {
                                                        setIsSelectComapnyDetail(
                                                          false
                                                        );
                                                        dispatch({
                                                          type: "GET_EACH_USER",
                                                          payload: {
                                                            token,
                                                            userid: user._id,
                                                          },
                                                        });
                                                        setuserCityPrice(
                                                          user?.cityprice
                                                        );
                                                      }}
                                                      itemId={user._id}
                                                      className="space-y-3 font-extrabold text-gray-700"
                                                      label={user.userName}
                                                      icon={
                                                        <UserIcon className="text-gray-500" />
                                                      }
                                                    />
                                                  </>
                                                )
                                              )}
                                              {singleCompany?.companies?.map(
                                                (singleSubCompany) => (
                                                  <>
                                                    <TreeItem
                                                      onClick={() => {
                                                        setIsSelectComapnyDetail(
                                                          true
                                                        );
                                                        dispatch({
                                                          type: "GET_EACH_COMPANY",
                                                          payload: {
                                                            token,
                                                            id: singleSubCompany?._id,
                                                          },
                                                        });
                                                        setcompanyCityPrice(
                                                          singleSubCompany?.cityprice
                                                        );
                                                      }}
                                                      itemId={
                                                        singleSubCompany?._id
                                                      }
                                                      label={
                                                        singleSubCompany?.companyName
                                                      }
                                                      className="space-y-1 font-extrabold text-yellow-700"
                                                      icon={
                                                        <OfficeBuildingIcon className="text-yellow-900" />
                                                      }
                                                    >
                                                      {singleSubCompany?.users?.map(
                                                        (user) => (
                                                          <>
                                                            <TreeItem
                                                              onClick={() => {
                                                                setIsSelectComapnyDetail(
                                                                  false
                                                                );
                                                                dispatch({
                                                                  type: "GET_EACH_USER",
                                                                  payload: {
                                                                    token,
                                                                    userid:
                                                                      user?._id,
                                                                  },
                                                                });
                                                                setuserCityPrice(
                                                                  user?.cityprice
                                                                );
                                                              }}
                                                              itemId={user?._id}
                                                              className="space-y-3 font-extrabold text-gray-700"
                                                              label={
                                                                user?.userName
                                                              }
                                                              icon={
                                                                <UserIcon className="text-gray-500" />
                                                              }
                                                            />
                                                          </>
                                                        )
                                                      )}
                                                    </TreeItem>
                                                  </>
                                                )
                                              )}
                                            </TreeItem>
                                          </div>
                                        )
                                      )}
                                    </TreeItem>
                                  </div>
                                ) : singleSearch?.userName ? (
                                  <div>
                                    {/* <TreeItem
                          onClick={() => {
                            setIsSelectComapnyDetail(true);
                            dispatch({
                              type: "GET_EACH_COMPANY",
                              payload: {
                                token,
                                id: singleSearch?.companyDetails[0]?._id,
                              },
                            });
                            // setcompanyCityPrice(
                            //   singleSearch?.cityprice
                            // );
                          }}
                          itemId={index}
                          label={singleSearch?.companyDetails[0]?.companyName}
                          className="space-y-1 font-extrabold text-yellow-700"
                          icon={
                            <OfficeBuildingIcon className="text-yellow-900" />
                          }
                        > */}
                                    <TreeItem
                                      onClick={() => {
                                        setIsSelectComapnyDetail(false);
                                        dispatch({
                                          type: "GET_EACH_USER",
                                          payload: {
                                            token,
                                            userid: singleSearch?._id,
                                          },
                                        });
                                        setuserCityPrice(
                                          singleSearch?.cityprice
                                        );
                                      }}
                                      itemId={singleSearch?._id}
                                      className="space-y-3 font-extrabold text-gray-700"
                                      label={`${singleSearch?.userName} (${singleSearch?.companyDetails[0]?.companyName})`}
                                      icon={
                                        <UserIcon className="text-gray-500" />
                                      }
                                    />
                                    {/* </TreeItem> */}
                                  </div>
                                ) : (
                                  <></>
                                )
                            )}
                          </div>
                        );
                      } else {
                        return (
                          <div className="text-red-600">No Result Found</div>
                        );
                      }
                    })()}
                  </>
                ) : (
                  <div className="">
                    {(() => {
                      if (user.role === "ADMIN") {
                        return (
                          <>
                            <TreeItem
                              onClick={() => {
                                setisSelect(true);
                                setIsSelectComapnyDetail(true);
                                dispatch({
                                  type: "GET_EACH_COMPANY",
                                  payload: { token, id: companyDetails._id },
                                });
                                setcompanyCityPrice(company?.cityprice);
                              }}
                              itemId={companyDetails?._id}
                              label={
                                companyDetails.companyName
                                  ? companyDetails.companyName
                                  : "loading..."
                              }
                              sx={{ fontWeight: "bold", width: "100%" }}
                              icon={
                                <FontAwesomeIcon
                                  icon={faBuilding}
                                  className="text-primary"
                                />
                              }
                              className="space-y-1 text-primary "
                            >
                              {(() => {
                                if (
                                  user?.permission?.userManagement?.view
                                    ?.permission === "ENABLE"
                                ) {
                                  return (
                                    <div>
                                      <TreeItem
                                        onClick={() => {
                                          setIsSelectComapnyDetail(false);
                                          dispatch({
                                            type: "GET_EACH_USER",
                                            payload: {
                                              token,
                                              userid: user._id,
                                            },
                                          });
                                          setuserCityPrice(user?.cityprice);
                                        }}
                                        itemId={user._id}
                                        label={user.userName}
                                        className="text-gray-700"
                                        icon={<UserIcon />}
                                      />
                                    </div>
                                  );
                                } else if (
                                  user?.permission?.userManagement?.view
                                    ?.permission === "BRANCH_LEVEL"
                                ) {
                                  return (
                                    <>
                                      {companyDetails?.users?.map(
                                        (singleUser) => {
                                          return (
                                            <>
                                              <TreeItem
                                                onClick={() => {
                                                  setIsSelectComapnyDetail(
                                                    false
                                                  );
                                                  dispatch({
                                                    type: "GET_EACH_USER",
                                                    payload: {
                                                      token,
                                                      userid: singleUser?._id,
                                                    },
                                                  });
                                                  setuserCityPrice(
                                                    singleUser?.cityprice
                                                  );
                                                }}
                                                itemId={singleUser?._id}
                                                className="space-y-3 font-extrabold text-gray-700"
                                                label={singleUser?.userName}
                                                icon={
                                                  <UserIcon className="text-gray-500" />
                                                }
                                              />
                                            </>
                                          );
                                        }
                                      )}
                                    </>
                                  );
                                } else if (
                                  user?.permission?.userManagement?.view
                                    ?.permission === "CHILD_COMPANY"
                                ) {
                                  return (
                                    <>
                                      {companyDetails?.users?.map(
                                        (singleUser) => {
                                          return (
                                            <>
                                              <TreeItem
                                                onClick={() => {
                                                  setIsSelectComapnyDetail(
                                                    false
                                                  );
                                                  dispatch({
                                                    type: "GET_EACH_USER",
                                                    payload: {
                                                      token,
                                                      userid: singleUser?._id,
                                                    },
                                                  });
                                                  setuserCityPrice(
                                                    singleUser?.cityprice
                                                  );
                                                }}
                                                itemId={singleUser?._id}
                                                className="space-y-3 font-extrabold text-gray-700"
                                                label={singleUser?.userName}
                                                icon={
                                                  <UserIcon className="text-gray-500" />
                                                }
                                              />
                                            </>
                                          );
                                        }
                                      )}
                                      {companyDetails?.company?.map(
                                        (singleCompany) => {
                                          return (
                                            <>
                                              <TreeItem
                                                onClick={() => {
                                                  setIsSelectComapnyDetail(
                                                    true
                                                  );
                                                  dispatch({
                                                    type: "GET_EACH_COMPANY",
                                                    payload: {
                                                      token,
                                                      id: singleCompany?._id,
                                                    },
                                                  });
                                                  setcompanyCityPrice(
                                                    singleCompany?.cityprice
                                                  );
                                                }}
                                                itemId={singleCompany?._id}
                                                className="space-y-1 text-yellow-900 "
                                                icon={
                                                  <FontAwesomeIcon
                                                    icon={faBuildingUser}
                                                    className="w-5 text-yellow-900 "
                                                  />
                                                }
                                                label={
                                                  singleCompany?.companyName
                                                }
                                              >
                                                {singleCompany?.users?.map(
                                                  (user) => (
                                                    <>
                                                      <TreeItem
                                                        onClick={() => {
                                                          setIsSelectComapnyDetail(
                                                            false
                                                          );
                                                          dispatch({
                                                            type: "GET_EACH_USER",
                                                            payload: {
                                                              token,
                                                              userid: user?._id,
                                                            },
                                                          });
                                                          setuserCityPrice(
                                                            user?.cityprice
                                                          );
                                                        }}
                                                        itemId={user._id}
                                                        className="space-y-3 font-extrabold text-gray-700"
                                                        label={user?.userName}
                                                        icon={
                                                          <UserIcon className="text-gray-500" />
                                                        }
                                                      />
                                                    </>
                                                  )
                                                )}
                                                {singleCompany?.company?.map(
                                                  (singleSubcompany) => (
                                                    <>
                                                      <TreeItem
                                                        onClick={() => {
                                                          setIsSelectComapnyDetail(
                                                            true
                                                          );
                                                          dispatch({
                                                            type: "GET_EACH_COMPANY",
                                                            payload: {
                                                              token,
                                                              id: singleSubcompany._id,
                                                            },
                                                          });
                                                          setcompanyCityPrice(
                                                            singleSubcompany?.cityprice
                                                          );
                                                        }}
                                                        itemId={
                                                          singleSubcompany._id
                                                        }
                                                        label={
                                                          singleSubcompany.companyName
                                                        }
                                                        className="space-y-1 font-extrabold text-yellow-700"
                                                        icon={
                                                          <OfficeBuildingIcon className="text-yellow-900" />
                                                        }
                                                      >
                                                        {singleSubcompany?.users?.map(
                                                          (user) => (
                                                            <>
                                                              <TreeItem
                                                                onClick={() => {
                                                                  setIsSelectComapnyDetail(
                                                                    false
                                                                  );
                                                                  dispatch({
                                                                    type: "GET_EACH_USER",
                                                                    payload: {
                                                                      token,
                                                                      userid:
                                                                        user?._id,
                                                                    },
                                                                  });
                                                                  setuserCityPrice(
                                                                    user?.cityprice
                                                                  );
                                                                }}
                                                                itemId={
                                                                  user._id
                                                                }
                                                                className="space-y-3 font-extrabold text-gray-700"
                                                                label={
                                                                  user.userName
                                                                }
                                                                icon={
                                                                  <UserIcon className="text-gray-500" />
                                                                }
                                                              />
                                                            </>
                                                          )
                                                        )}
                                                      </TreeItem>
                                                    </>
                                                  )
                                                )}
                                              </TreeItem>
                                            </>
                                          );
                                        }
                                      )}
                                    </>
                                  );
                                } else {
                                  return <></>;
                                }
                              })()}
                            </TreeItem>
                          </>
                        );
                      } else {
                        return (
                          <>
                            <TreeItem
                              onClick={() => {
                                setisSelect(true);
                                setIsSelectComapnyDetail(true);
                                dispatch({
                                  type: "GET_EACH_COMPANY",
                                  payload: { token, id: companyDetails._id },
                                });
                                setcompanyCityPrice(company?.cityprice);
                              }}
                              itemId={companyDetails?._id}
                              label={
                                companyDetails.companyName
                                  ? companyDetails.companyName
                                  : "loading..."
                              }
                              sx={{ fontWeight: "bold", width: "100%" }}
                              icon={
                                <FontAwesomeIcon
                                  icon={faBuilding}
                                  className="text-primary"
                                />
                              }
                              className="space-y-1 text-primary "
                            >
                              {(() => {
                                if (
                                  user?.permission?.userManagement?.view
                                    ?.permission === "ENABLE"
                                ) {
                                  return (
                                    <div>
                                      <TreeItem
                                        onClick={() => {
                                          setIsSelectComapnyDetail(false);
                                          dispatch({
                                            type: "GET_EACH_USER",
                                            payload: {
                                              token,
                                              userid: user._id,
                                            },
                                          });
                                          setuserCityPrice(user?.cityprice);
                                        }}
                                        itemId={user._id}
                                        label={user.userName}
                                        className="text-gray-700"
                                        icon={<UserIcon />}
                                      />
                                    </div>
                                  );
                                } else if (
                                  user?.permission?.userManagement?.view
                                    ?.permission === "BRANCH_LEVEL"
                                ) {
                                  return (
                                    <>
                                      {companyDetails?.users?.map(
                                        (singleUser) => {
                                          return (
                                            <>
                                              <TreeItem
                                                onClick={() => {
                                                  setIsSelectComapnyDetail(
                                                    false
                                                  );
                                                  dispatch({
                                                    type: "GET_EACH_USER",
                                                    payload: {
                                                      token,
                                                      userid: singleUser?._id,
                                                    },
                                                  });
                                                  setuserCityPrice(
                                                    singleUser?.cityprice
                                                  );
                                                }}
                                                itemId={singleUser?._id}
                                                className="space-y-3 font-extrabold text-gray-700"
                                                label={singleUser?.userName}
                                                icon={
                                                  <UserIcon className="text-gray-500" />
                                                }
                                              />
                                            </>
                                          );
                                        }
                                      )}
                                    </>
                                  );
                                } else if (
                                  user?.permission?.userManagement?.view
                                    ?.permission === "CHILD_COMPANY"
                                ) {
                                  return (
                                    <>
                                      {companyDetails?.users?.map(
                                        (singleUser) => {
                                          return (
                                            <>
                                              <TreeItem
                                                onClick={() => {
                                                  setIsSelectComapnyDetail(
                                                    false
                                                  );
                                                  dispatch({
                                                    type: "GET_EACH_USER",
                                                    payload: {
                                                      token,
                                                      userid: singleUser?._id,
                                                    },
                                                  });
                                                  setuserCityPrice(
                                                    singleUser?.cityprice
                                                  );
                                                }}
                                                itemId={singleUser?._id}
                                                className="space-y-3 font-extrabold text-gray-700"
                                                label={singleUser?.userName}
                                                icon={
                                                  <UserIcon className="text-gray-500" />
                                                }
                                              />
                                            </>
                                          );
                                        }
                                      )}
                                      {companyDetails?.company?.map(
                                        (singleCompany) => {
                                          return (
                                            <>
                                              <TreeItem
                                                onClick={() => {
                                                  setIsSelectComapnyDetail(
                                                    true
                                                  );
                                                  dispatch({
                                                    type: "GET_EACH_COMPANY",
                                                    payload: {
                                                      token,
                                                      id: singleCompany._id,
                                                    },
                                                  });
                                                  setcompanyCityPrice(
                                                    singleCompany?.cityprice
                                                  );
                                                }}
                                                itemId={singleCompany._id}
                                                className="space-y-1 text-yellow-900 "
                                                icon={
                                                  <FontAwesomeIcon
                                                    icon={faBuildingUser}
                                                    className="w-5 text-yellow-900 "
                                                  />
                                                }
                                                label={
                                                  singleCompany.companyName
                                                }
                                              >
                                                {singleCompany?.users?.map(
                                                  (user) => (
                                                    <>
                                                      <TreeItem
                                                        onClick={() => {
                                                          setIsSelectComapnyDetail(
                                                            false
                                                          );
                                                          dispatch({
                                                            type: "GET_EACH_USER",
                                                            payload: {
                                                              token,
                                                              userid: user._id,
                                                            },
                                                          });
                                                          setuserCityPrice(
                                                            user?.cityprice
                                                          );
                                                        }}
                                                        itemId={user._id}
                                                        className="space-y-3 font-extrabold text-gray-700"
                                                        label={user.userName}
                                                        icon={
                                                          <UserIcon className="text-gray-500" />
                                                        }
                                                      />
                                                    </>
                                                  )
                                                )}
                                                {singleCompany?.company?.map(
                                                  (singleSubcompany) => (
                                                    <>
                                                      <TreeItem
                                                        onClick={() => {
                                                          setIsSelectComapnyDetail(
                                                            true
                                                          );
                                                          dispatch({
                                                            type: "GET_EACH_COMPANY",
                                                            payload: {
                                                              token,
                                                              id: singleSubcompany._id,
                                                            },
                                                          });
                                                          setcompanyCityPrice(
                                                            singleSubcompany?.cityprice
                                                          );
                                                        }}
                                                        itemId={
                                                          singleSubcompany._id
                                                        }
                                                        label={
                                                          singleSubcompany.companyName
                                                        }
                                                        className="space-y-1 font-extrabold text-yellow-700"
                                                        icon={
                                                          <OfficeBuildingIcon className="text-yellow-900" />
                                                        }
                                                      >
                                                        {singleSubcompany?.users?.map(
                                                          (user) => (
                                                            <>
                                                              <TreeItem
                                                                onClick={() => {
                                                                  setIsSelectComapnyDetail(
                                                                    false
                                                                  );
                                                                  dispatch({
                                                                    type: "GET_EACH_USER",
                                                                    payload: {
                                                                      token,
                                                                      userid:
                                                                        user?._id,
                                                                    },
                                                                  });
                                                                  setuserCityPrice(
                                                                    user?.cityprice
                                                                  );
                                                                }}
                                                                itemId={
                                                                  user?._id
                                                                }
                                                                className="space-y-3 font-extrabold text-gray-700"
                                                                label={
                                                                  user?.userName
                                                                }
                                                                icon={
                                                                  <UserIcon className="text-gray-500" />
                                                                }
                                                              />
                                                            </>
                                                          )
                                                        )}
                                                      </TreeItem>
                                                    </>
                                                  )
                                                )}
                                              </TreeItem>
                                            </>
                                          );
                                        }
                                      )}
                                    </>
                                  );
                                } else {
                                  return <></>;
                                }
                              })()}
                            </TreeItem>
                          </>
                        );
                      }
                    })()}
                  </div>
                )}
              </SimpleTreeView>
            </div>
            {isSelect ? (
              <div className="w-full">
                {isSelectComapnyDetail ? (
                  <div>
                    <div className="h-12 flex relative lg:top-0 justify-between pr-6 md:pr-10 lg:px-10 mx-auto text-left md:text-center text-gray-600 rounded-md">
                      <div className="text-lg font-semibold pl-5 mt-2 lg:mt-0">
                        Company Details
                      </div>
                      <div className="flex space-x-5">
                        {companyDetailsLoading === false && (
                          <div>
                            {(user?.role === "ADMIN" ||
                              user?.permission?.userManagement?.addUsers
                                ?.permission === "ENABLE") && (
                              <button
                                type="button"
                                onClick={() => setShowModal(true)}
                              >
                                <FontAwesomeIcon icon={faUserPlus} />
                                <div className="text-xs text-gray-700 font-body">
                                  Add User
                                </div>
                              </button>
                            )}

                            {/* Start of Main modal */}
                            {showModal && (
                              <>
                                <Modal
                                  isAddUser={true}
                                  heading="Add User"
                                  addOnClick={addUserHandler}
                                  cancelOnClick={() => {
                                    setShowModal(false);
                                  }}
                                  addButtonLabel="Add User"
                                  userNameInput={(e) => {
                                    setuserDetailBody({
                                      ...userDetailBody,
                                      userName: e.target.value,
                                    });
                                  }}
                                  firstNameInput={(e) => {
                                    setuserDetailBody({
                                      ...userDetailBody,
                                      firstName: e.target.value,
                                    });
                                  }}
                                  lastNameInput={(e) => {
                                    setuserDetailBody({
                                      ...userDetailBody,
                                      lastName: e.target.value,
                                    });
                                  }}
                                  emailInput={(e) => {
                                    setuserDetailBody({
                                      ...userDetailBody,
                                      email: e.target.value,
                                    });
                                  }}
                                  passwordInput={(e) => {
                                    setuserDetailBody({
                                      ...userDetailBody,
                                      password: e.target.value,
                                    });
                                  }}
                                  confirmPasswordInput={(e) => {
                                    setuserDetailBody({
                                      ...userDetailBody,
                                      confirmPassword: e.target.value,
                                    });
                                  }}
                                  mobileNumberInput={(e) => {
                                    setuserDetailBody({
                                      ...userDetailBody,
                                      mobile: e.target.value,
                                    });
                                  }}
                                />
                                <div
                                  className="fixed inset-0 z-40 bg-black opacity-25"
                                  onClick={() => {
                                    setShowModal(false);
                                  }}
                                ></div>
                              </>
                            )}
                            {/* End of Main modal */}
                          </div>
                        )}

                        {companyDetailsLoading === false && (
                          <div>
                            {user?.role === "ADMIN" && (
                              <button onClick={() => setShowModalCompany(true)}>
                                <FontAwesomeIcon icon={faBuilding} />
                                <FontAwesomeIcon
                                  icon={faPlus}
                                  className="w-3 h-3 mb-2"
                                />
                                <div className="text-xs text-gray-700 font-body">
                                  Add Company
                                </div>
                              </button>
                            )}
                            {/* Start of Main modal */}
                            {showModalCompany && (
                              <>
                                <Modal
                                  heading="Add Company"
                                  isAddCompany={true}
                                  addOnClick={addCompanyHandler}
                                  cancelOnClick={() => {
                                    setShowModalCompany(false);
                                  }}
                                  addButtonLabel="Add Company"
                                  companyNameInput={(e) => {
                                    setcompanyDetailBody({
                                      ...companyDetailBody,
                                      companyName: e.target.value,
                                    });
                                  }}
                                  companyAddressInput={(e) => {
                                    setcompanyDetailBody({
                                      ...companyDetailBody,
                                      companyAddress: e.target.value,
                                    });
                                  }}
                                  companyEmailInput={(e) => {
                                    setcompanyDetailBody({
                                      ...companyDetailBody,
                                      companyEmail: e.target.value,
                                    });
                                  }}
                                  companyWebsiteInput={(e) => {
                                    setcompanyDetailBody({
                                      ...companyDetailBody,
                                      companyWebsite: e.target.value,
                                    });
                                  }}
                                  companyGstInput={(e) => {
                                    setcompanyDetailBody({
                                      ...companyDetailBody,
                                      gst_vat: e.target.value,
                                    });
                                  }}
                                />
                                <div
                                  className="fixed inset-0 z-40 bg-black opacity-25"
                                  onClick={() => {
                                    setShowModalCompany(false);
                                  }}
                                ></div>
                              </>
                            )}
                            {/* End of Main modal */}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="mx-0 lg:mx-3 2lg:mx-6">
                      <div className="px-3 lg:px-5 sm:py-5 rounded-sm shadow-md bg-gray-50 h-screen 2lg:w-full">
                        {openEditCompany && (
                          <>
                            <Modal
                              heading="Edit Company"
                              isEditCompany={true}
                              addOnClick={editCompanyHandler}
                              cancelOnClick={() => {
                                setopenEditCompany(false);
                              }}
                              addButtonLabel="Save"
                              companyNameInput={(e) => {
                                seteditCompanyDetail({
                                  ...editCompanyDetail,
                                  companyName: e.target.value,
                                });
                              }}
                              companyEditAddressInput={(e) => {
                                seteditCompanyDetail({
                                  ...editCompanyDetail,
                                  address: e.target.value,
                                });
                              }}
                              companyEmailInput={(e) => {
                                seteditCompanyDetail({
                                  ...editCompanyDetail,
                                  email: e.target.value,
                                });
                              }}
                              companyWebsiteInput={(e) => {
                                seteditCompanyDetail({
                                  ...editCompanyDetail,
                                  website: e.target.value,
                                });
                              }}
                              companyAddressInput={(e) => {
                                seteditCompanyDetail({
                                  ...editCompanyDetail,
                                  address: e.target.value,
                                });
                              }}
                              companyGstInput={(e) => {
                                seteditCompanyDetail({
                                  ...editCompanyDetail,
                                  gst_vat: e.target.value,
                                });
                              }}
                              companyCreditLimitInput={(e) => {
                                seteditCompanyDetail({
                                  ...editCompanyDetail,
                                  creditLimit: e.target.value,
                                });
                              }}
                              companyDiscountInput={(e) => {
                                seteditCompanyDetail({
                                  ...editCompanyDetail,
                                  discount: e.target.value,
                                });
                              }}
                              companyMarkupInput={(e) => {
                                seteditCompanyDetail({
                                  ...editCompanyDetail,
                                  markUp: e.target.value,
                                });
                              }}
                              companyLogoInput={(e) => {
                                setcompanyLogo(e.target.files[0]);
                              }}
                              companyEditAddressValue={
                                editCompanyDetail?.address
                              }
                              companyNameValue={editCompanyDetail?.companyName}
                              companyEmailValue={editCompanyDetail.email}
                              companyWebsiteValue={editCompanyDetail.website}
                              companyAddressValue={editCompanyDetail.address}
                              companyGstValue={editCompanyDetail.gst_vat}
                              companyCreditLimitValue={
                                editCompanyDetail.creditLimit
                              }
                              companyDiscountValue={editCompanyDetail.discount}
                              companyMarkupValue={editCompanyDetail.markUp}
                            />
                            <div
                              className="fixed inset-0 z-40 bg-black opacity-25"
                              onClick={() => {
                                setopenEditCompany(false);
                              }}
                            ></div>
                          </>
                        )}
                        <div className="sm:flex justify-between">
                          <div className="flex items-center mt-5 space-x-6">
                            <div className="object-contain rounded-lg">
                              {eachCompanyDetails?.companyLogo ? (
                                <img
                                  src={
                                    eachCompanyDetails?.companyLogo?.secure_url
                                  }
                                  alt=""
                                  className="object-contain rounded-full w-28"
                                />
                              ) : (
                                <FontAwesomeIcon
                                  icon={faBuilding}
                                  className="w-10 h-10 text-gray-500"
                                />
                              )}
                            </div>
                            <div className="space-y-2">
                              <div className="flex items-center space-x-2">
                                <FontAwesomeIcon
                                  icon={faBuilding}
                                  className="w-3 text-gray-500"
                                />
                                <div className="text-xl font-medium font-body">
                                  {eachCompanyDetails?.companyName}
                                </div>
                              </div>
                              <div className="flex items-center space-x-2 ">
                                <FontAwesomeIcon
                                  icon={faEnvelope}
                                  className="w-3 text-gray-500"
                                />
                                <div className="tracking-wide  font-body">
                                  {eachCompanyDetails.email}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="flex gap-x-4 items-center">
                            {user?.role === "ADMIN" && (
                              <div className="flex items-center justify-between">
                                <span className="text-green-600 text-sm">
                                  With
                                </span>
                                <Switch
                                  color="primary"
                                  checked={
                                    eachCompanyDetails?.companyPermission
                                      ?.flatRateBooking?.MeetAndGreet ===
                                    "WITHOUT"
                                  }
                                  onClick={() => {
                                    console.log("clicked", eachUserDetails);
                                    console.log(
                                      eachCompanyDetails?.companyPermission
                                        ?.flatRateBooking?.MeetAndGreet ===
                                        "WITHOUT",
                                      "meet and greet"
                                    );

                                    if (
                                      eachCompanyDetails?.companyPermission
                                        ?.flatRateBooking?.MeetAndGreet ===
                                        undefined ||
                                      eachCompanyDetails?.companyPermission
                                        ?.flatRateBooking?.MeetAndGreet ===
                                        "WITH"
                                    ) {
                                      dispatch({
                                        type: "UPDATE_COMPANY_PERMISSION",
                                        payload: {
                                          token,
                                          id: eachCompanyDetails?._id,
                                          body: {
                                            MeetAndGreet: "WITHOUT",
                                          },
                                        },
                                      });
                                    }

                                    if (
                                      eachCompanyDetails?.companyPermission
                                        ?.flatRateBooking?.MeetAndGreet ===
                                      "WITHOUT"
                                    ) {
                                      console.log("calling without");

                                      dispatch({
                                        type: "UPDATE_COMPANY_PERMISSION",
                                        payload: {
                                          token,
                                          id: eachCompanyDetails?._id,
                                          body: {
                                            MeetAndGreet: "WITH",
                                          },
                                        },
                                      });
                                    }
                                  }}
                                />
                                <span className="text-slate-600 text-sm">
                                  Without
                                </span>
                              </div>
                            )}

                            {user?.role === "ADMIN" && (
                              <div
                                onClick={() => {
                                  setopenEditCompany(true);

                                  seteditCompanyDetail({
                                    companyId: eachCompanyDetails?._id,
                                    companyName: eachCompanyDetails.companyName,
                                    email: eachCompanyDetails.email,
                                    website: eachCompanyDetails.website,
                                    address: eachCompanyDetails.address,
                                    gst_vat: eachCompanyDetails.gst_vat,
                                    creditLimit: eachCompanyDetails.creditLimit,
                                    discount: eachCompanyDetails.discount,
                                    markUp: eachCompanyDetails.markUp,
                                  });
                                }}
                                className="cursor-pointer relative top-5 sm:top-0 text-right sm:text-center sm:right-0"
                              >
                                <FontAwesomeIcon
                                  icon={faEdit}
                                  className="w-10 text-gray-500 mr-6 sm:ml-0"
                                />
                                <div className="text-sm text-gray-700 font-body">
                                  Edit Company
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="sm:flex sm:justify-between">
                          <div className="mt-5 lg:mt-10 space-y-3 lg:space-y-5">
                            <CompanyDetailsItem
                              iconname={faGlobe}
                              label="Website"
                              value={eachCompanyDetails.website}
                            />

                            <CompanyDetailsItem
                              iconname={faLocationPin}
                              label="Address"
                              value={eachCompanyDetails.address}
                            />
                          </div>
                          <div className="mt-3 sm:mt-5 lg:mt-10 space-y-3 lg:space-y-5">
                            <CompanyDetailsItem
                              iconname={faMobile}
                              label="Phone"
                              value={eachCompanyDetails?.mobile}
                            />
                            <CompanyDetailsItem
                              iconname={faMoneyBill1Wave}
                              label="GST/VAT"
                              value={eachCompanyDetails.gst_vat}
                            />
                          </div>
                        </div>
                        {/* <div>
                          <div>
                            <div className="mt-5 text-lg font-bold font-body border-b text-primary border-primary border-priamry">
                              Contact Details
                            </div>
                          </div>
                          <div className="sm:flex sm:items-center sm:justify-between mt-3 space-y-5 sm:space-y-0">
                            <CompanyDetailsItem
                              iconname={faUser}
                              label="Contact Name"
                              value="Drivado"
                            />

                            <CompanyDetailsItem
                              iconname={faPhone}
                              label="Mobile"
                              value="123456789"
                            />
                          </div>
                        </div> */}

                        <div className="mt-4">
                          <div className="flex justify-between w-full mx-auto text-center text-gray-600 border-b border-primary">
                            <div className="text-lg font-bold text-primary font-body">
                              Credit limit
                            </div>
                          </div>
                          <div className="sm:flex sm:justify-between space-y-3 sm:space-y-0 mt-3">
                            <div className="flex items-center space-x-2">
                              <div className="text-base text-black  font-body">
                                Total unpaid booking:
                              </div>
                              <div className="text-base font-semibold text-primary font-body">
                                USD{" "}
                                {eachCompanyDetails?.totalUnpaidBooking &&
                                  Math.round(
                                    eachCompanyDetails?.totalUnpaidBooking
                                  )}
                              </div>
                            </div>
                            <div className="flex space-x-2">
                              <div className="text-base text-black font-body">
                                Available Limit:
                              </div>
                              <div className="text-base font-semibold text-green-700 font-body">
                                USD{" "}
                                {eachCompanyDetails?.availableLimit &&
                                  Math.round(
                                    eachCompanyDetails?.availableLimit
                                  )}
                              </div>
                            </div>
                          </div>
                        </div>

                        {user?.role === "ADMIN" && (
                          <div className="mt-6">
                            <div className="flex justify-between w-full mx-auto text-center text-gray-600 border-b border-primary">
                              <div className="text-lg font-bold text-primary font-body">
                                Company settings
                              </div>
                            </div>
                            <div className="xs:flex justify-between mt-3">
                              <div className="flex items-center space-x-2">
                                <div className="text-base text-black font-body">
                                  Credit Limit:
                                </div>
                                <div className="text-base font-semibold text-primary font-body">
                                  USD {eachCompanyDetails?.creditLimit}
                                </div>
                              </div>
                              <div className="flex space-x-10">
                                <div className="flex space-x-2">
                                  <div className="text-base text-black font-body">
                                    Discount:
                                  </div>
                                  <div className="text-base font-semibold text-green-700 font-body">
                                    {eachCompanyDetails?.discount} %
                                  </div>
                                </div>
                                <div className="flex space-x-2">
                                  <div className="text-base text-black font-body">
                                    Markup:
                                  </div>
                                  <div className="text-base font-semibold text-green-700 font-body">
                                    {eachCompanyDetails?.markUp} %
                                  </div>
                                </div>
                              </div>
                            </div>
                            {user?.role === "ADMIN" && (
                              <>
                                <div className="pt-3 font-bold border-b border-black">
                                  City Price
                                </div>
                                <div className="flex justify-end pt-2">
                                  <div
                                    onClick={() => {
                                      dispatch({
                                        type: "EDIT_COMPANY",
                                        payload: {
                                          body: {
                                            cityprice: companyCityPrice,
                                          },
                                          token,
                                          companyId: eachCompanyDetails._id,
                                        },
                                      });
                                    }}
                                    className="text-sm cursor-pointer text-gray-100 font-body bg-teal-700 px-3 py-1.5 rounded-lg hover:shadow-md"
                                  >
                                    Save Changes
                                  </div>
                                </div>
                              </>
                            )}
                            {user?.role === "ADMIN" && (
                              <div className="flex space-x-3 items-center">
                                <Select
                                  options={options}
                                  onChange={(e) => {
                                    setnewcityprice({
                                      ...newcityprice,
                                      city: e.value,
                                    });
                                  }}
                                  className="w-48 mt-3"
                                />
                                <TextField
                                  onChange={(e) => {
                                    setnewcityprice({
                                      ...newcityprice,
                                      discount: e.target.value,
                                    });
                                  }}
                                  label="Discount"
                                  variant="standard"
                                />
                                <TextField
                                  onChange={(e) => {
                                    setnewcityprice({
                                      ...newcityprice,
                                      markup: e.target.value,
                                    });
                                  }}
                                  label="Markup"
                                  variant="standard"
                                />
                                <button
                                  className="text-sm cursor-pointer text-gray-100 font-body bg-teal-700 px-5 py-1.5 rounded-lg hover:shadow-md"
                                  onClick={() => {
                                    setcompanyCityPrice([
                                      ...companyCityPrice,
                                      newcityprice,
                                    ]);
                                    setnewcityprice({});
                                  }}
                                >
                                  Add
                                </button>
                              </div>
                            )}
                            {user?.role === "ADMIN" &&
                              companyCityPrice?.map((cp) => (
                                <>
                                  <div className="flex justify-between items-center">
                                    <div>City: {cp?.city}</div>
                                    <div>Mark up: {cp?.markup} %</div>
                                    <div>Discount: {cp?.discount} %</div>
                                    <div
                                      className="cursor-pointer"
                                      onClick={() => {
                                        // deleteCityPrice(cp)
                                        setcompanyCityPrice(
                                          companyCityPrice.filter(
                                            (each) => each.city !== cp.city
                                          )
                                        );
                                      }}
                                    >
                                      <FontAwesomeIcon icon={faTrash} />
                                    </div>
                                  </div>
                                </>
                              ))}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="w-full ">
                    <div className="flex justify-between px-16 mx-auto text-center text-primary ">
                      {openUserEditModal && (
                        <>
                          <Modal
                            heading="Edit User"
                            isEditUser={true}
                            addOnClick={editUserHandler}
                            cancelOnClick={() => {
                              setOpenUserEditModal(false);
                            }}
                            addButtonLabel="Save"
                            userNameInput={(e) => {
                              seteditUserDetail({
                                ...editUserDetail,
                                userName: e.target.value,
                              });
                            }}
                            firstNameInput={(e) => {
                              seteditUserDetail({
                                ...editUserDetail,
                                firstName: e.target.value,
                              });
                            }}
                            lastNameInput={(e) => {
                              seteditUserDetail({
                                ...editUserDetail,
                                lastName: e.target.value,
                              });
                            }}
                            emailInput={(e) => {
                              seteditUserDetail({
                                ...editUserDetail,
                                email: e.target.value,
                              });
                            }}
                            mobileNumberInput={(e) => {
                              seteditUserDetail({
                                ...editUserDetail,
                                mobile: e.target.value,
                              });
                            }}
                            usermarkupInput={(e) => {
                              seteditUserDetail({
                                ...editUserDetail,
                                userMarkup: e.target.value,
                              });
                            }}
                            userDiscountInput={(e) => {
                              seteditUserDetail({
                                ...editUserDetail,
                                userDiscount: e.target.value,
                              });
                            }}
                            usermarkupInputValue={editUserDetail?.userMarkup}
                            userDiscountValue={editUserDetail?.userDiscount}
                            userNameValue={editUserDetail?.userName}
                            firstNameValue={editUserDetail?.firstName}
                            lastNameValue={editUserDetail?.lastName}
                            emailInputValue={editUserDetail?.email}
                            mobileNumberValue={editUserDetail?.mobile}
                          />
                          <div
                            className="fixed inset-0 z-40 bg-black opacity-25"
                            onClick={() => {
                              setOpenUserEditModal(false);
                            }}
                          ></div>
                        </>
                      )}
                      {updatePasswordModal && (
                        <>
                          <Modal
                            heading="Update Password"
                            isUpdatePassword={true}
                            addButtonLabel="Save"
                            addOnClick={() => {
                              const body = {
                                password: updatedPaswordValue,
                              };
                              dispatch({
                                type: "UPDATE_PASSWORD_BY_ID",
                                payload: {
                                  userId: eachUserDetails?._id,
                                  body,
                                  token,
                                },
                              });
                            }}
                            cancelOnClick={() => {
                              setupdatePasswordModal(false);
                            }}
                            userUpdatePasswordInput={(e) => {
                              setupdatedPaswordValue(e.target.value);
                            }}
                            userUpdatePasswordValue={updatedPaswordValue}
                          />
                          <div
                            className="fixed inset-0 z-40 bg-black opacity-25"
                            onClick={() => {
                              setupdatePasswordModal(false);
                            }}
                          ></div>
                        </>
                      )}
                      <div className="text-lg font-semibold ">User Details</div>
                      <div className="flex space-x-4">
                        {user?.role === "ADMIN" ? (
                          <div
                            onClick={() => {
                              setOpenUserEditModal(true);
                              seteditUserDetail({
                                userName: eachUserDetails?.userName,
                                firstName: eachUserDetails?.firstName,
                                lastName: eachUserDetails?.lastName,
                                email: eachUserDetails?.email,
                                mobile: eachUserDetails?.mobile,
                                userMarkup: eachUserDetails?.markup,
                                userDiscount: eachUserDetails?.discount,
                              });
                            }}
                            className="cursor-pointer item-center hover:text-red-700"
                          >
                            <FontAwesomeIcon icon={faUserPen} />
                            <div className="text-sm">Edit</div>
                          </div>
                        ) : (
                          (user?.permission?.userManagement?.edit ===
                            "ENABLE" ||
                            user?.permission?.userManagement?.edit ===
                              "CHILD_COMPANY" ||
                            user?.permission?.userManagement?.edit ===
                              "BRANCH_LEVEL") && (
                            <>
                              <div
                                onClick={() => {
                                  setOpenUserEditModal(true);
                                  seteditUserDetail({
                                    userName: eachUserDetails?.userName,
                                    firstName: eachUserDetails?.firstName,
                                    lastName: eachUserDetails?.lastName,
                                    email: eachUserDetails?.email,
                                    mobile: eachUserDetails?.mobile,
                                  });
                                }}
                                className="cursor-pointer item-center hover:text-red-700"
                              >
                                <FontAwesomeIcon icon={faUserPen} />
                                <div className="text-sm">Edit</div>
                              </div>
                            </>
                          )
                        )}
                        {user?.role === "ADMIN" && (
                          <div
                            onClick={() => {
                              setShowPermissionModal(true);
                              setUserPermissionUpdate({
                                newBooking: {
                                  permission:
                                    eachUserDetails?.permission?.newBooking
                                      ?.permission,
                                  performSearch: {
                                    permission:
                                      eachUserDetails?.permission?.newBooking
                                        ?.performSearch?.permission,
                                  },
                                  MakeBooking: {
                                    permission:
                                      eachUserDetails?.permission?.newBooking
                                        ?.MakeBooking?.permission,
                                  },
                                },

                                flatRateBooking: {
                                  permission:
                                    eachUserDetails?.permission?.flatRateBooking
                                      ?.permission,
                                },

                                manageBooking: {
                                  permission:
                                    eachUserDetails?.permission?.manageBooking
                                      ?.permission,
                                  viewBooking: {
                                    permission:
                                      eachUserDetails?.permission?.manageBooking
                                        ?.viewBooking?.permission,
                                  },
                                  cancelBooking: {
                                    permission:
                                      eachUserDetails?.permission?.manageBooking
                                        ?.cancelBooking?.permission,
                                  },
                                  assignAffiliate: {
                                    permission:
                                      eachUserDetails?.permission?.manageBooking
                                        ?.assignAffiliate?.permission,
                                  },
                                  assignDriver: {
                                    permission:
                                      eachUserDetails?.permission?.manageBooking
                                        ?.assignDriver?.permission,
                                  },
                                  markAsPaid: {
                                    permission:
                                      eachUserDetails?.permission?.manageBooking
                                        ?.markAsPaid?.permission,
                                  },
                                  sms_Document: {
                                    permission:
                                      eachUserDetails?.permission?.manageBooking
                                        ?.sms_Document?.permission,
                                  },
                                },

                                affiliate: {
                                  permission:
                                    eachUserDetails?.permission?.affiliate
                                      ?.permission,
                                },

                                regions: {
                                  permission:
                                    eachUserDetails?.permission?.regions
                                      ?.permission,
                                },
                                flatRegions: {
                                  permission:
                                    eachUserDetails?.permission?.flatRegions
                                      ?.permission,
                                },
                                generalSettings: {
                                  permission:
                                    eachUserDetails?.permission?.generalSettings
                                      ?.permission,
                                },
                                userManagement: {
                                  permission:
                                    eachUserDetails?.permission?.userManagement
                                      ?.permission,
                                  view: {
                                    permission:
                                      eachUserDetails?.permission
                                        ?.userManagement?.view?.permission,
                                  },
                                  edit: {
                                    permission:
                                      eachUserDetails?.permission
                                        ?.userManagement?.edit?.permission,
                                  },
                                  addUsers: {
                                    permission:
                                      eachUserDetails?.permission
                                        ?.userManagement?.addUsers?.permission,
                                  },
                                },
                                vehicleTypes: {
                                  permission:
                                    eachUserDetails?.permission?.vehicleTypes
                                      ?.permission,
                                },
                                imageUploader: {
                                  permission:
                                    eachUserDetails?.permission?.imageUploader
                                      ?.permission,
                                },
                                apiDocs: {
                                  permission:
                                    eachUserDetails?.permission?.apiDocs
                                      ?.permission,
                                },
                              });
                            }}
                            className="cursor-pointer item-center hover:text-red-700"
                          >
                            <FontAwesomeIcon icon={faUserGear} />
                            <div className="text-sm">Permission</div>
                          </div>
                        )}

                        {user?.role === "ADMIN" && (
                          <div
                            onClick={() => {
                              setupdatePasswordModal(true);
                            }}
                            className="item-center hover:text-red-700 cursor-pointer"
                          >
                            <FontAwesomeIcon icon={faKey} />
                            <div className="text-sm">Update password</div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="px-5 py-2  bg-gray-100 rounded-md shadow-md h-[40vh] 2lg:h-auto overflow-y-auto 2lg:overflow-y-hidden scrollbar">
                      <div className="flex 2lg:flex-col xl:flex-row justify-between space-y-3">
                        <div className="flex items-center space-x-2">
                          <div className="flex items-center justify-center w-12 h-12 xl:w-16 xl:h-16 bg-gray-300 rounded-full ">
                            <FontAwesomeIcon
                              icon={faUser}
                              className="text-gray-500 rounded-full w-5 h-5 xl:w-7 xl:h-7"
                            />
                          </div>
                          <div className="space-y-0.5">
                            <div className="text-base font-medium w-40 lg:w-80 xl:w-44 2xl:w-80 truncate">
                              {eachUserDetails?.userName}
                            </div>
                            <div className="flex items-center space-x-1.5">
                              <div className="text-base text-black">
                                <h2 className="hidden 2xl:block">Email:</h2>
                                <FontAwesomeIcon
                                  icon={faEnvelope}
                                  className="2xl:hidden text-gray-500 w-5 h-4"
                                />
                              </div>
                              <div className="text-base text-gray-600 w-40 lg:w-80 xl:w-44 2xl:w-80 truncate">
                                {eachUserDetails?.email}
                              </div>
                            </div>
                            <div className="flex items-center space-x-2">
                              <div className="text-base text-black">Role:</div>
                              <div className={"text-base text-gray-600"}>
                                {eachUserDetails?.role}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div>
                          {user?.role === "ADMIN" && (
                            <div className="flex space-x-10 items-start ">
                              <div className="flex items-center space-x-1 ">
                                <div className="text-sm xl:text-base text-black">
                                  Account Status:
                                </div>
                                <div
                                  className={`text-sm xl:text-base   ${
                                    eachUserDetails?.userLocked
                                      ? "text-red-700"
                                      : "text-green-700"
                                  } `}
                                >
                                  {eachUserDetails?.userLocked
                                    ? "Locked "
                                    : "Active"}
                                </div>
                              </div>
                              <div className="-mt-2">
                                <div className="flex items-center justify-between">
                                  <FontAwesomeIcon
                                    icon={faLockOpen}
                                    className={` w-4 h-4 
                              ${
                                !eachUserDetails?.userLocked
                                  ? "text-green-500"
                                  : "text-gray-500"
                              }`}
                                  />
                                  <Switch
                                    color="primary"
                                    checked={eachUserDetails?.userLocked}
                                    onClick={() => {
                                      if (eachUserDetails?.userLocked) {
                                        dispatch({
                                          type: "UNLOCK_USER",
                                          payload: {
                                            userId: eachUserDetails?._id,
                                            token,
                                          },
                                        });
                                      } else {
                                        dispatch({
                                          type: "LOCK_USER",
                                          payload: {
                                            userId: eachUserDetails?._id,
                                            token,
                                          },
                                        });
                                      }
                                    }}
                                  />
                                  <FontAwesomeIcon
                                    icon={faLock}
                                    className={`w-4 h-4  ${
                                      eachUserDetails?.userLocked
                                        ? "text-red-500"
                                        : "text-gray-500"
                                    }`}
                                  />
                                </div>
                              </div>
                            </div>
                          )}

                          {/* role update start */}
                          {user?.role === "ADMIN" && (
                            <div className="flex space-x-10 items-start ">
                              <div className="flex items-center space-x-1 ">
                                <div className="text-sm xl:text-base text-black">
                                  User Role:
                                </div>
                                <div
                                  className={`text-sm xl:text-base text-green-700  `}
                                >
                                  {eachUserDetails?.role}
                                </div>
                              </div>
                              <div className="-mt-2">
                                <div className="flex items-center">
                                  <div className="text-xs font-semibold">
                                    USER
                                  </div>
                                  <Switch
                                    color="primary"
                                    checked={eachUserDetails?.role === "ADMIN"}
                                    onClick={() => {
                                      if (eachUserDetails?.role === "ADMIN") {
                                        dispatch({
                                          type: "USER_ROLE_UPDATE",
                                          payload: {
                                            userId: eachUserDetails?._id,
                                            body: {
                                              role: "USER",
                                            },
                                            token,
                                          },
                                        });
                                      } else {
                                        dispatch({
                                          type: "USER_ROLE_UPDATE",
                                          payload: {
                                            userId: eachUserDetails?._id,
                                            body: {
                                              role: "ADMIN",
                                            },
                                            token,
                                          },
                                        });
                                      }
                                    }}
                                  />
                                  <div className="text-xs font-semibold">
                                    ADMIN
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                          {/* role update end */}
                        </div>
                      </div>
                      <div className="px-2 py-2 pt-5 text-lg border-t-2 border-gray-300">
                        <div className="flex justify-between">
                          <div>
                            <div className="flex items-center space-x-2">
                              <div className="text-sm xl:text-base text-black">
                                Name:
                              </div>
                              <div className="text-sm xl:text-base text-gray-600 w-40 xl:w-60 2xl:w-80 truncate">
                                {eachUserDetails?.firstName +
                                  " " +
                                  eachUserDetails?.lastName}
                              </div>
                            </div>
                            <div className="flex items-center space-x-2">
                              <div className="text-sm xl:text-base text-black">
                                Email:
                              </div>
                              <div className="text-sm xl:text-base text-gray-600 w-40 xl:w-60 2xl:w-80 truncate">
                                {eachUserDetails?.email}
                              </div>
                            </div>
                            <div className="flex items-center space-x-2">
                              <div className="text-sm xl:text-base text-black">
                                Mobile:
                              </div>
                              <div className="text-sm xl:text-base text-gray-600">
                                {eachUserDetails?.mobile}
                              </div>
                            </div>
                          </div>
                          <div>
                            <div className="flex items-center space-x-2">
                              <div className="text-sm xl:text-base text-black">
                                Position:
                              </div>
                              <div className="text-sm xl:text-base text-gray-600">
                                {eachUserDetails?.position}
                              </div>
                            </div>
                            <div className="flex items-center space-x-2">
                              <div className="text-sm xl:text-base text-black">
                                Language:
                              </div>
                              <div className="text-sm xl:text-base text-gray-600">
                                {eachUserDetails?.language}
                              </div>
                            </div>
                            <div className="flex items-center space-x-2">
                              <div className="text-sm xl:text-base text-black">
                                Currency:
                              </div>
                              <div className="text-sm xl:text-base text-gray-600">
                                USD
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="flex justify-between px-2 py-2 border-t-2 border-gray-300 ">
                        <div className="flex items-center space-x-1">
                          <div className="text-base text-black">
                            Total Unpaid booking:
                          </div>
                          <div className="text-base text-black font-semibold">
                            USD{" "}
                            {eachUserDetails?.unpaidBooking &&
                              Math.round(eachUserDetails?.unpaidBooking)}
                          </div>
                        </div>
                        <div className="flex items-center space-x-1">
                          <div className="text-base text-black">
                            Availabel Limit:
                          </div>
                          <div className="text-base text-black font-semibold">
                            USD{" "}
                            {eachUserDetails?.company?.availableLimit &&
                              Math.round(
                                eachUserDetails?.company?.availableLimit
                              )}
                          </div>
                        </div>
                      </div>
                      <div className="flex justify-between px-2 py-2 border-t-2 border-gray-300 ">
                        <div className="flex items-center space-x-1">
                          <div className="text-base text-black">Mark Up:</div>
                          <div className="text-base text-black font-semibold">
                            {eachUserDetails?.markup} %
                          </div>
                        </div>
                        <div className="flex items-center space-x-1">
                          <div className="text-base text-black">Discount:</div>
                          <div className="text-base text-black font-semibold">
                            {eachUserDetails?.discount} %
                          </div>
                        </div>
                      </div>
                      {user?.role === "ADMIN" && (
                        <>
                          <div className="px-2 font-semibold border-b border-black">
                            City Price
                          </div>
                          <div className="flex justify-end ">
                            <div
                              onClick={() => {
                                dispatch({
                                  type: "EDIT_USER",
                                  payload: {
                                    body: {
                                      cityprice: userCityPrice,
                                    },
                                    token,
                                    userId: eachUserDetails._id,
                                  },
                                });
                              }}
                              className="text-sm cursor-pointer text-gray-100 font-body bg-teal-700 px-2 py-1 rounded-lg hover:shadow-md mt-2"
                            >
                              Save Changes
                            </div>
                          </div>
                        </>
                      )}
                      {user?.role === "ADMIN" && (
                        <div className="flex space-x-3 items-center">
                          <Select
                            options={options}
                            onChange={(e) => {
                              setnewusercityprice({
                                ...newusercityprice,
                                city: e.value,
                              });
                            }}
                            className="w-48 mt-3"
                          />
                          <TextField
                            onChange={(e) => {
                              setnewusercityprice({
                                ...newusercityprice,
                                discount: e.target.value,
                              });
                            }}
                            label="Discount"
                            variant="standard"
                          />
                          <TextField
                            onChange={(e) => {
                              setnewusercityprice({
                                ...newusercityprice,
                                markup: e.target.value,
                              });
                            }}
                            label="Markup"
                            variant="standard"
                          />
                          <button
                            className="bg-teal-700 text-gray-100 px-5 py-1.5 rounded-lg hover:shadow-md"
                            onClick={() => {
                              setuserCityPrice([
                                ...userCityPrice,
                                newusercityprice,
                              ]);
                              setnewusercityprice({});
                            }}
                          >
                            Add
                          </button>
                        </div>
                      )}
                      {user?.role === "ADMIN" &&
                        userCityPrice?.map((cp) => (
                          <>
                            <div className="flex justify-between items-center">
                              <div>City: {cp?.city}</div>
                              <div>Mark up: {cp?.markup}%</div>
                              <div>Discount: {cp?.discount}%</div>
                              <div
                                className="cursor-pointer"
                                onClick={() => {
                                  // deleteCityPrice(cp)
                                  setuserCityPrice(
                                    userCityPrice.filter(
                                      (each) => each.city !== cp.city
                                    )
                                  );
                                }}
                              >
                                <FontAwesomeIcon icon={faTrash} />
                              </div>
                            </div>
                          </>
                        ))}
                    </div>
                    {showPermissionModal && (
                      <>
                        <Modal
                          addButtonLabel="Update"
                          heading="Permission"
                          setUserPermissionUpdate={setUserPermissionUpdate}
                          userPermissionUpdate={userPermissionUpdate}
                          cancelOnClick={() => {
                            setShowPermissionModal(false);
                          }}
                          addOnClick={updateUserPermissionHandler}
                          isPermission={true}
                        />
                        <div
                          className="fixed inset-0 z-40 bg-black opacity-25"
                          onClick={() => {
                            setShowModalCompany(false);
                          }}
                        ></div>
                      </>
                    )}
                  </div>
                )}
              </div>
            ) : (
              <div className="items-center justify-center mx-auto flex relative w-full bg-gray-50">
                <div>
                  <FontAwesomeIcon
                    icon={faUser}
                    className="w-52 h-52 text-gray-200"
                  />
                </div>
                <div className="absolute translate-x-20 translate-y-32">
                  <FontAwesomeIcon
                    icon={faBuilding}
                    className="w-52 h-52 text-gray-200"
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(UserManagement);

export const CompanyDetailsItem = ({ iconname, label, value }) => {
  return (
    <div className="flex items-center content-start space-x-1">
      <FontAwesomeIcon icon={iconname} className="w-4 h-5 text-red-500" />
      <div className="text-base text-black font-body">{label}: </div>
      <div className="text-base text-gray-700 font-body">{value}</div>
    </div>
  );
};
